import {Injectable} from '@angular/core';
import {Patient} from '../model/user/Patient';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ClinicalSccaiResultDialogComponent} from './dialogs/clinical-sccai-result-dialog/clinical-sccai-result-dialog.component';
import {EORTCResultDialogComponent} from './dialogs/eortc-result-dialog/eortc-result-dialog.component';
import {EQ5D5LResultDialogComponent} from './dialogs/eq5-d5-l-result-dialog/eq5-d5-l-result-dialog.component';
import {HADSResultDialogComponent} from './dialogs/hads-result-dialog/hads-result-dialog.component';
import {HBIResultDialogComponent} from './dialogs/hbi-result-dialog/hbi-result-dialog.component';
import {IBDDiskResultDialogComponent} from './dialogs/ibddisk-result-dialog/ibddisk-result-dialog.component';
import {IPAQSFResultDialogComponent} from './dialogs/ipaqsf-result-dialog/ipaqsf-result-dialog.component';
import {MIAHCDResultDialogComponent} from './dialogs/miahcd-result-dialog/miahcd-result-dialog.component';
import {MIAHUCResultDialogComponent} from './dialogs/miahuc-result-dialog/miahuc-result-dialog.component';
import {MMAS8ResultDialogComponent} from './dialogs/mmas8-result-dialog/mmas8-result-dialog.component';
import {PatientSCCAIResultDialogComponent} from './dialogs/patient-sccai-result-dialog/patient-sccai-result-dialog.component';
import {PHQ9ResultDialogComponent} from './dialogs/phq9-result-dialog/phq9-result-dialog.component';
import {PSQIResultDialogComponent} from './dialogs/psqi-result-dialog/psqi-result-dialog.component';
import {SIBDQResultDialogComponent} from './dialogs/sibdq-result-dialog/sibdq-result-dialog.component';
import {TSQMResultDialogComponent} from './dialogs/tsqm-result-dialog/tsqm-result-dialog.component';
import {WPAIResultDialogComponent} from './dialogs/wpai-result-dialog/wpai-result-dialog.component';
import {PRISMResultDialogComponent} from './dialogs/prism-result-dialog/prism-result-dialog.component';
import {IBDQResultDialogComponent} from './dialogs/ibdq-result-dialog/ibdq-result-dialog.component';
import {LarsResultDialogComponent} from './dialogs/lars-result-dialog/lars-result-dialog.component';
@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(private dialog: MatDialog) {
  }

  openClinicalSCCAIDialog(r: any, userRole: any, patient: Patient) {
    return this.dialog.open(ClinicalSccaiResultDialogComponent, {
      width: '1200px',
      height: '700px',
      // tslint:disable-next-line:max-line-length
      data: {
        id: r.id,
        date: r.id.split('-')[0],
        results: r.results,
        finalScore: r.finalScore,
        patientChosen: patient,
        role: userRole,
        read: r.read,
        warning: r.warning,
        evaluation: r.evaluation
      }
    });
  }

  openEORTCDialog(r, userRole, patient): MatDialogRef<any> {
    return this.dialog.open(EORTCResultDialogComponent, {
      width: '1500px',
      height: '720px',
      data: {
        id: r.id,
        date: r.id.split('-')[0],
        results: r.results,
        patientChosen: patient,
        role: userRole,
        read: r.read,
        warning: r.warning,
        evaluation: r.evaluation
      }
    });
  }

  openEQ5D5LDialog(r, userRole, patient): MatDialogRef<any> {
    return this.dialog.open(EQ5D5LResultDialogComponent, {
      width: '900px',
      height: '700px',
      data: {
        id: r.id,
        date: r.id.split('-')[0],
        results: r.results,
        scale: r.scale,
        patientChosen: patient,
        role: userRole,
        read: r.read,
        warning: r.warning,
        evaluation: r.evaluation
      }
    });
  }

  openHADSDialog(r: any, userRole: any, patient: Patient) {
    return this.dialog.open(HADSResultDialogComponent, {
      width: '1200px',
      height: '700px',
      // tslint:disable-next-line:max-line-length
      data: {
        id: r.id,
        date: r.id.split('-')[0],
        results: r.results,
        finalScore: r.finalScore,
        patientChosen: patient,
        role: userRole,
        read: r.read,
        warning: r.warning,
        evaluation: r.evaluation
      }
    });
  }

  openHBIDialog(r, userRole, patient): MatDialogRef<any> {
    return this.dialog.open(HBIResultDialogComponent, {
      width: '800px',
      height: '670px',
      // tslint:disable-next-line:max-line-length
      data: {
        id: r.id,
        date: r.id.split('-')[0],
        results: r.results,
        complications: r.complications,
        finalScore: r.finalScore,
        patientChosen: patient,
        role: userRole,
        read: r.read,
        warning: r.warning,
        evaluation: r.evaluation
      }
    });
  }

  openIBDDiskDialog(r, userRole, patient): MatDialogRef<any> {
    return this.dialog.open(IBDDiskResultDialogComponent, {
      width: '800px',
      height: '670px',
      data: {
        id: r.id,
        date: r.id.split('-')[0],
        results: r.results,
        patientChosen: patient,
        role: userRole,
        read: r.read,
        warning: r.warning,
        evaluation: r.evaluation
      }
    });
  }
  openIPAQSFDialog(r: any, userRole: any, patient: Patient) {
    return this.dialog.open(IPAQSFResultDialogComponent, {
      width: '1200px',
      height: '700px',
      data: {
        id: r.id,
        date: r.id.split('-')[0],
        results: r.results,
        diagnosis: r.diagnosis,
        patientChosen: patient,
        role: userRole,
        read: r.read,
        warning: r.warning,
        evaluation: r.evaluation
      }
    });
  }

  openMIAHCDDialog(r: any, userRole: any, patient: Patient) {
    return this.dialog.open(MIAHCDResultDialogComponent, {
      width: '1200px',
      height: '700px',
      data: {
        id: r.id,
        date: r.id.split('-')[0],
        results: r.results,
        finalScore: r.finalScore,
        patientChosen: patient,
        role: userRole,
        read: r.read,
        warning: r.warning,
        evaluation: r.evaluation
      }
    });
  }

  openMIAHUCDialog(r: any, userRole: any, patient: Patient) {
    return this.dialog.open(MIAHUCResultDialogComponent, {
      width: '1200px',
      height: '700px',
      data: {
        id: r.id,
        date: r.id.split('-')[0],
        results: r.results,
        finalScore: r.finalScore,
        patientChosen: patient,
        role: userRole,
        read: r.read,
        warning: r.warning,
        evaluation: r.evaluation
      }
    });
  }

  openMMAS8Dialog(r: any, userRole: any, patient: Patient) {
    return this.dialog.open(MMAS8ResultDialogComponent, {
      width: '1200px',
      height: '700px',
      data: {
        id: r.id,
        date: r.id.split('-')[0],
        results: r.results,
        finalScore: r.finalScore,
        patientChosen: patient,
        role: userRole,
        read: r.read,
        warning: r.warning,
        evaluation: r.evaluation
      }
    });
  }

  openPatientSCCAIDialog(r: any, userRole: any, patient: Patient) {
    return this.dialog.open(PatientSCCAIResultDialogComponent, {
      width: '1200px',
      height: '700px',
      data: {
        id: r.id,
        date: r.id.split('-')[0],
        results: r.results,
        finalScore: r.finalScore,
        patientChosen: patient,
        role: userRole,
        read: r.read,
        warning: r.warning,
        evaluation: r.evaluation
      }
    });
  }

  openPHQ9Dialog(r: any, userRole: any, patient: Patient) {
    return this.dialog.open(PHQ9ResultDialogComponent, {
      width: '1200px',
      height: '700px',
      data: {
        id: r.id,
        date: r.id.split('-')[0],
        results: r.results,
        finalScore: r.finalScore,
        patientChosen: patient,
        role: userRole,
        read: r.read,
        warning: r.warning,
        evaluation: r.evaluation
      }
    });
  }

  openPRISMDialog(r: any, userRole: any, patient: Patient) {
    return this.dialog.open(PRISMResultDialogComponent, {
      width: '1000px',
      height: '650px',
      data: {
        id: r.id,
        date: r.id.split('-')[0],
        self: r.self,
        disease: r.disease,
        distance: r.distance,
        patientChosen: patient,
        role: userRole,
        read: r.read,
        warning: r.warning,
        evaluation: r.evaluation
      }
    });
  }

  openPSQIDialog(r: any, userRole: any, patient: Patient) {
    return this.dialog.open(PSQIResultDialogComponent, {
      width: '1200px',
      height: '700px',
      data: {
        id: r.id,
        date: r.id.split('-')[0],
        results: r.results,
        finalScore: r.finalScore,
        patientChosen: patient,
        role: userRole,
        read: r.read,
        warning: r.warning,
        evaluation: r.evaluation
      }
    });
  }


  openSIBDQDialog(r, userRole, patient): MatDialogRef<any> {
    return this.dialog.open(SIBDQResultDialogComponent, {
      width: '1200px',
      height: '700px',
      data: {
        id: r.id,
        date: r.id.split('-')[0],
        results: r.results,
        patientChosen: patient,
        role: userRole,
        read: r.read,
        warning: r.warning,
        evaluation: r.evaluation
      }
    });
  }


  openIBDQDialog(r, userRole, patient): MatDialogRef<any> {
    return this.dialog.open(IBDQResultDialogComponent, {
      width: '1200px',
      height: '700px',
      data: {
        id: r.id,
        date: r.id.split('-')[0],
        results: r.results,
        patientChosen: patient,
        role: userRole,
        read: r.read,
        warning: r.warning,
        evaluation: r.evaluation
      }
    });
  }

  openLARSDialog(r, userRole, patient): MatDialogRef<any> {
    return this.dialog.open(LarsResultDialogComponent, {
      width: '1200px',
      height: '700px',
      data: {
        id: r.id,
        date: r.id.split('-')[0],
        results: r.results,
        patientChosen: patient,
        role: userRole,
        read: r.read,
        warning: r.warning,
        evaluation: r.evaluation
      }
    });
  }

  openTSQMDialog(r, userRole, patient): MatDialogRef<any> {
    return this.dialog.open(TSQMResultDialogComponent, {
      width: '1200px',
      height: '700px',
      data: {
        id: r.id,
        date: r.id.split('-')[0],
        results: r.results,
        patientChosen: patient,
        role: userRole,
        read: r.read,
        warning: r.warning,
        evaluation: r.evaluation
      }
    });
  }

  openWPAIDialog(r, userRole, patient): MatDialogRef<any> {
    return this.dialog.open(WPAIResultDialogComponent, {
      width: '1200px',
      height: '700px',
      data: {
        id: r.id,
        date: r.id.split('-')[0],
        results: r.results,
        patientChosen: patient,
        role: userRole,
        read: r.read,
        warning: r.warning,
        evaluation: r.evaluation
      }
    });
  }
}
